// Mapeamento entre o projeto vindo da API e os campos do formulário de
// informações gerais. O responsável muda por audiência: usuário da organização
// no app (responsibleUserId) e nome livre no portal (responsibleName).
export const buildDefaultValues = (
  privacyByDesign,
  { responsibleField = 'user', mode = 'new' } = {},
) => ({
  name: privacyByDesign?.name || '',
  description: privacyByDesign?.description || '',
  ...(responsibleField === 'user'
    ? { responsibleUserId: privacyByDesign?.responsibleUser?.id || '' }
    : { responsibleName: privacyByDesign?.responsibleUser?.name || '' }),
  ...(mode === 'new' && {
    departmentId: '',
    quizTemplateId: '',
  }),
})

export const buildGeneralInfoPayload = (
  values,
  { responsibleField = 'user' } = {},
) => ({
  name: values.name,
  description: values.description,
  ...(responsibleField === 'user'
    ? { responsibleUserId: values.responsibleUserId }
    : { responsibleName: values.responsibleName }),
})

export const buildCreatePayload = (
  values,
  { responsibleField = 'user' } = {},
) => ({
  ...buildGeneralInfoPayload(values, { responsibleField }),
  departmentId: values.departmentId,
  quizTemplateId: values.quizTemplateId,
})
